import React from "react";
import { ArrowUpRight } from "lucide-react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./Hero.css";

function Hero() {
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  console.log(user);
  return (
    <section className="Hero">
      <h1 className="jumbo-text">Happy reading,</h1>
      <h1 className="jumbo-text">{user ? user.display_name : "Friend"}</h1>
      <p>
        Dive into a world of limitless reading with LeftKoast, the ultimate
        destination for streaming eBooks anytime, anywhere. Whether you're into
        gripping thrillers, timeless classics, or the latest bestsellers,
        LeftKoast gives you instant access to a curated library across every
        genre.
      </p>
      <p>
        No downloads. No wait times. Just open, stream, and read on any device.
        Discover your next favorite book – effortlessly.
      </p>
      <button onClick={() => navigate(user ? "/library" : "/login")}>
        Start Reading <ArrowUpRight size={18} />
      </button>
    </section>
  );
}

export default Hero;
